import styled from 'styled-components';

export const MessageHistoryDropdownContainer = styled.div`
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  background: ${({ theme }) => theme.colorPalette.white};
  border: 1px solid ${({ theme }) => theme.colorPalette.grey.grey3};
  z-index: 1000;
  max-height: 231px;
  overflow-y: auto;
`;

export const MessageHistoryItem = styled.div<{ isActive: boolean }>`
  padding: 14px 20px;
  cursor: pointer;
  border-bottom: 1px solid #e9ecef;
  transition: all 0.15s ease;
  color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey8 : theme.colorPalette.grey.grey6};

  background-color: ${({ theme, isActive }) =>
    isActive
      ? theme.colorPalette.isDarkMode
        ? theme.colorPalette.turquoise.dark
        : theme.colorPalette.turquoise.accent2
      : 'transparent'};

  &:last-child {
    border-bottom: none;
  }

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
`;
